const BASE_SERVICE_URL = import.meta.env.VITE_BASE_SERVICE_URL

export function getFullUploadUrl(fileUrl: string, baseServiceUrl: string = BASE_SERVICE_URL) {
  // 已经是完整 URL（手动输入的外部链接）则原样返回
  if (/^https?:\/\//i.test(fileUrl))
    return fileUrl
  return `${baseServiceUrl}${fileUrl}`
}
